import React from 'react';
import "./Footer.css";
import { FacebookFilled, InstagramFilled, LinkedinOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <div className='footer-container'>
            <div className='footer-main-container'>
                <div>
                    <img src={require("../../images/landing/hero-logo.avif")} height="150px" width="100%" alt="footer" />
                    <span>Take your aerospace products to new heights with Aero Fasteners - your trusted partner for high-quality fasteners that keep your innovations secure and soaring.</span>
                </div>
                <div>
                    <span>Quick Links</span>
                    <Link to="/">Home</Link>
                    {/* <Link to="/products">Products</Link> */}
                    <Link to="/products-list">Products List</Link>
                    <Link to="/products-categories">Product Categories</Link>
                    <Link to="/why-choose-us">Why Choose Us</Link>
                    <Link to="/quality-assurance">Quality Assurance</Link>
                    <Link to="/raw-materials">Raw Materials</Link>
                    <Link to="/about">About Us</Link>
                    <Link to="/contact">Contact Us</Link>
                </div>
                <div>
                    <span>Policies</span>
                    <Link to="/terms-and-conditions-for-purchase">T&C for Purchase</Link>
                    <Link to="/po-terms">T&C for Sales</Link>
                </div>
                <div>
                    <span>Social Links</span>
                    <div className='social-links'>
                        <a href="/" target='_blank' rel='noreferrer'><LinkedinOutlined /></a>
                        <a href="/" target='_blank' rel='noreferrer'><FacebookFilled /></a>
                        <a href="/" target='_blank' rel='noreferrer'><InstagramFilled /></a>
                    </div>
                </div>
            </div>
            <div className='footer-copyright'>APPYARD © 2023 ALL RIGHTS RESERVED <a href="https://appyard.co.in" target='_blank' rel='noreferrer'>Designed & Developed By AppYard</a>.</div>
        </div>
    )
}

export default Footer
